import { apiFetch } from "@core/index";
import { buildQueryParams } from "@shared/utils/functions";
import { useQuery } from "@tanstack/react-query";
import { enqueueSnackbar } from "notistack";
import { apiEndpoint } from "../utils/constants";
import { IGetAllPartnerChannels, IPartnerChannelRow } from "../utils/types";

export type PartnerChannelsListResponse = {
  data: IPartnerChannelRow[];
  pagination: {
    total: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
  };
};

export const useGetAllPartnerChannels = (config: IGetAllPartnerChannels) => {
  return useQuery<
    PartnerChannelsListResponse,
    Error,
    PartnerChannelsListResponse,
    (string | boolean | undefined)[]
  >({
    queryKey: [
      "partnerChannels",
      config.data.pageNumber,
      config.data.pageSize,
      config.data.includeInactive,
      config.data.searchQuery ?? "",
      config.data.orderBy ?? "",
      config.data.order ?? "",
      config.data.updatedSince ?? "",
    ],
    queryFn: async () => {
      const queryString = buildQueryParams(config.data);

      const url = `${apiEndpoint}?${queryString}`;

      try {
        const data = await apiFetch<PartnerChannelsListResponse>(url);
        return data;
      } catch (error) {
        const message =
          error instanceof Error
            ? error.message
            : "Failed to fetch the Partner Channels List.";

        enqueueSnackbar(message, {
          variant: "error",
          autoHideDuration: 5000,
          preventDuplicate: true,
        });
        throw error;
      }
    },

    placeholderData: (prev) => prev,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });
};
